import {
  Lock, PersonStanding, Turtle, Columns2, Armchair, Lasso, Anchor, Undo2, StepBack, Tornado, Worm, FlipVertical2,
  Equal, Flag, Repeat2, FastForward, ArrowDownToLine, LogOut, ArrowLeftRight, Waypoints, Dumbbell, Lightbulb,
  Grab, Scissors, RotateCw, Baby,
} from 'lucide-react';
import { GiLeg, GiButterfly, GiCrucifix, GiCrabClaw, GiCrossedBones, GiMountedKnight, GiPerpendicularRings, GiHook } from 'react-icons/gi';
import type { ComponentType, SVGProps } from 'react';
import { TechniqueType } from '../types';

// Shared icon shape — accepts both Lucide (LucideIcon) and react-icons (IconType).
// Both libraries render an SVG element and accept SVG props plus `size`.
export type IconComponent = ComponentType<SVGProps<SVGSVGElement> & { size?: number | string }>;

// Canonical icon mapping for positions (categories) and technique types.
// This is the single source of truth — render these wherever a position or
// type label appears. Keep CATEGORY_ICONS keys in sync with the ids in
// src/data/categories.ts; TYPE_ICONS is keyed by the TechniqueType enum, so
// the compiler flags any missing type.
export const CATEGORY_ICONS: Record<string, IconComponent> = {
  'closed-guard': Lock,
  'standing': PersonStanding,
  'mount': GiMountedKnight,
  'side-control': GiPerpendicularRings,
  'turtle': Turtle,
  'half-guard': Columns2,
  'butterfly-guard': GiButterfly,
  'seated-guard': Armchair,
  'spider-lasso': Lasso,
  'dlr': Anchor,
  'rdlr': Undo2,
  'k-guard': GiHook,
  'x-guard': GiCrossedBones,
  'back-control': StepBack,
  'crucifix': GiCrucifix,
  'slx': GiLeg,
  'fifty-fifty': Equal,
  'berimbolo': Tornado,
  'worm-guard': Worm,
  'crab-ride': GiCrabClaw,
  'retention': FlipVertical2,
  // Wrestling par terre. Named from the top wrestler's view (rides and
  // turns), which is why none of the guard icons above fit them.
  'front-headlock': Grab,
  'leg-ride': Scissors,
  'leg-lace': RotateCw,
  'cradle': Baby,
};

export const TYPE_ICONS: Record<TechniqueType, IconComponent> = {
  [TechniqueType.Submission]: Flag,
  [TechniqueType.Sweep]: Repeat2,
  [TechniqueType.Pass]: FastForward,
  [TechniqueType.Takedown]: ArrowDownToLine,
  [TechniqueType.Escape]: LogOut,
  [TechniqueType.Counter]: ArrowLeftRight,
  [TechniqueType.Transition]: Waypoints,
  [TechniqueType.Drill]: Dumbbell,
  [TechniqueType.Concept]: Lightbulb,
};
